import axios from "axios";

// In production (deployed), use relative path so API calls go to same domain (hamarsathi.com/api)
// In development (localhost), use the env variable
const isDev = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
export const BACKEND_URL = isDev ? (process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000") : "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jjodi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("jjodi_token");
      if (window.location.pathname.startsWith("/app")) {
        window.location.href = "/login";
      } else if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}

/**
 * Normalise a photo URL so it always points to the correct backend host.
 * Handles:
 *  - Relative paths like /api/uploads/serve/...
 *  - Old absolute URLs with wrong host (http://127.0.0.1:8000/..., http://192.168.x.x/...)
 *  - Correct absolute https URLs for our own domain (treated as relative)
 *  - External CDN URLs (Unsplash etc.) — left as-is
 */
export function photoUrl(url) {
  if (!url) return "";
  // If it contains our uploads serve path, always extract and use relative path
  // This fixes mixed-content errors caused by old http://127.x.x.x:8000/api/uploads/serve/ URLs
  if (url.includes("/api/uploads/serve/")) {
    const filename = url.split("/api/uploads/serve/")[1];
    return `${BACKEND_URL}/api/uploads/serve/${filename}`;
  }
  // Pure filename (no slashes) — treat as an upload filename
  if (!url.includes("/") && !url.startsWith("http")) {
    return `${BACKEND_URL}/api/uploads/serve/${url}`;
  }
  // External images (Unsplash, Firebase CDN, etc.) — leave as-is
  if (url.startsWith("https://") || url.startsWith("http://")) return url;
  // Relative path already
  return BACKEND_URL + (url.startsWith("/") ? url : "/" + url);
}

export default api;
